module.exports = __webpack_public_path__ + "static/media/magnifier.989d30b9.svg";